interface ErrorFallbackProps {
  schema?: string;
  deliveryId?: string;
  message?: string;
  errorMessage?: string;
}

const ErrorFallback = ({ schema, deliveryId, message, errorMessage }: ErrorFallbackProps) => (
  <div className="border-2 border-red-500 bg-red-50 p-4 my-2 font-mono text-xs text-red-700">
    <p className="font-bold mb-1">Block render error</p>
    {schema && <p>Schema: {schema}</p>}
    {deliveryId && <p>ID: {deliveryId}</p>}
    {message && <p>Context: {message}</p>}
    {errorMessage && <p>Error: {errorMessage}</p>}
  </div>
);

export default ErrorFallback;
